import http from '@/api/http';

export default async (username: string): Promise<void> => {
    const endpoint = '/account';
    await http.delete(endpoint, {
        data: {
            username
        }
    });
};
